import parseFileSuggestions from './file/parseFileSuggestions';
import parseMeetingTimeSuggestions from './meetingTimes/parseMeetingTimeSuggestions';
import parseStickyNotesSuggestions from './stickyNotes/parseStickyNotesSuggestions';
import parseVivaTopicSuggestions from './vivaTopics/parseVivaTopicSuggestions';
import parseContactSuggestions from './contacts/parseContactSuggestions';
import type {
    SonoraDataProviderConfig,
    SonoraFileSuggestion,
    UserDataServiceSuggestions,
} from 'owa-editor-sonora-types';
import { Suggestion } from 'owa-userdataservice';
import { DataProviderType } from '@augloop-types/honeybee';

const MAX_FILE_COUNT = 3;
const MAX_TOPICFILE_COUNT = 2;

export default function getDataProviderToSuggestionsDictionary(
    dataProviders: DataProviderType[],
    config: SonoraDataProviderConfig,
    suggestions: Suggestion[]
) {
    const dataProviderToSuggestionsDictionary: UserDataServiceSuggestions = dataProviders.reduce(
        (dictionary, provider) => {
            dictionary[provider] = [];
            return dictionary;
        },
        {}
    );

    suggestions.map(suggestion => {
        switch (suggestion.sourceInfo.type) {
            case DataProviderType.SubstrateSearchQueryStickynotes:
                dataProviderToSuggestionsDictionary[
                    DataProviderType.SubstrateSearchQueryStickynotes
                ] = parseStickyNotesSuggestions(suggestion);
                break;
            case DataProviderType.SubstrateSearchSuggestions:
                dataProviderToSuggestionsDictionary[
                    DataProviderType.SubstrateSearchSuggestions
                ] = parseFileSuggestions(suggestion);
                break;
            case DataProviderType.MeetingTimes:
                dataProviderToSuggestionsDictionary[
                    DataProviderType.MeetingTimes
                ] = parseMeetingTimeSuggestions(suggestion);
                break;
            case DataProviderType.VivaTopics:
                dataProviderToSuggestionsDictionary[
                    DataProviderType.VivaTopics
                ] = parseVivaTopicSuggestions(suggestion);
                break;
            case DataProviderType.ChainedContacts:
                dataProviderToSuggestionsDictionary[
                    DataProviderType.ChainedContacts
                ] = parseContactSuggestions(suggestion);
                break;
            default:
                break;
        }
    });

    reduceFileCount(dataProviderToSuggestionsDictionary, config);

    return dataProviderToSuggestionsDictionary;
}

function reduceFileCount(
    dataProviderToSuggestionsDictionary: UserDataServiceSuggestions,
    config: SonoraDataProviderConfig
) {
    const numFiles = (dataProviderToSuggestionsDictionary[
        DataProviderType.SubstrateSearchSuggestions
    ] as SonoraFileSuggestion)?.suggestions?.length;

    const numTopicFiles = (dataProviderToSuggestionsDictionary[
        DataProviderType.VivaTopics
    ] as SonoraFileSuggestion)?.suggestions?.length;

    if (numFiles > MAX_FILE_COUNT && numTopicFiles > MAX_TOPICFILE_COUNT) {
        (dataProviderToSuggestionsDictionary[
            DataProviderType.SubstrateSearchSuggestions
        ] as SonoraFileSuggestion).suggestions = (dataProviderToSuggestionsDictionary[
            DataProviderType.SubstrateSearchSuggestions
        ] as SonoraFileSuggestion).suggestions.slice(0, MAX_FILE_COUNT);

        (dataProviderToSuggestionsDictionary[
            DataProviderType.VivaTopics
        ] as SonoraFileSuggestion).suggestions = (dataProviderToSuggestionsDictionary[
            DataProviderType.VivaTopics
        ] as SonoraFileSuggestion).suggestions.slice(0, MAX_TOPICFILE_COUNT);
    }

    if (config.maxResults !== undefined) {
        Object.entries(dataProviderToSuggestionsDictionary).forEach(([dataProviderType]) => {
            const dataProviderSuggestions = (dataProviderToSuggestionsDictionary[
                dataProviderType
            ] as SonoraFileSuggestion)?.suggestions;
            if (dataProviderSuggestions) {
                (dataProviderToSuggestionsDictionary[
                    dataProviderType
                ] as SonoraFileSuggestion).suggestions = dataProviderSuggestions.slice(
                    0,
                    config.maxResults
                );
            }
        });
    }
}
